import { useCallback, useEffect, useState } from "react";
import { getUnreadNotificationCount } from "../Services/apiService";

const readStoredCount = () => {
  const stored = localStorage.getItem("NotificationCountData");
  return stored != null && stored !== "" ? Number(stored) : 0;
};

export const useNotificationCount = () => {
  const [notifiCount, setNotifiCount] = useState(readStoredCount);

  const NotificationCount = useCallback(async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadNotificationCount({ forceRefresh });
      if (count != null) {
        setNotifiCount(Number(count) || 0);
      }
    } catch (e) {
      // preserve previous count on error
    }
  }, []);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (!sessionId) return undefined;

    NotificationCount({ forceRefresh: true });

    const handleUserLoggedIn = () => {
      NotificationCount({ forceRefresh: true });
    };

    const handleCountUpdated = (event) => {
      const count = event?.detail?.count;
      if (count != null) {
        setNotifiCount(Number(count) || 0);
      }
    };

    window.addEventListener("userLoggedIn", handleUserLoggedIn);
    window.addEventListener("notificationCountUpdated", handleCountUpdated);

    return () => {
      window.removeEventListener("userLoggedIn", handleUserLoggedIn);
      window.removeEventListener("notificationCountUpdated", handleCountUpdated);
    };
  }, [NotificationCount]);

  return { notifiCount, setNotifiCount, NotificationCount };
};
